import { Link } from "react-bootstrap-icons";
import CatalogItemPreviewComponent from "../../components/gradingandrefurb/refurb-steps/catalog-item-preview";
import { CatalogItem } from "../../external";
import { useCircleDarkMode } from "../../hooks/useCircleDarkMode";
import { PMGradingRow } from "../../workers/pmui";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Spinner from "react-bootstrap/Spinner";
import { CC2MasterSheetDataRow } from "./types";

const PMUICatalogueInfo = ({
  pmGradingRow,
  onChangeCatalogue,
  currentCC2,
  getLatestCatalogueForActiveSku,
  isRetrievingCatalogueItemForCurrentSKU,
  disabled = false,
}: {
  pmGradingRow: PMGradingRow;
  currentCC2?: CC2MasterSheetDataRow;
  onChangeCatalogue?: () => void;
  getLatestCatalogueForActiveSku: () => void;
  isRetrievingCatalogueItemForCurrentSKU: boolean;
  disabled?: boolean;
}) => {
  const darkMode = useCircleDarkMode();

  const rrpPence = pmGradingRow.catalogue.rrp * 100;
  const catalogInfoShim: CatalogItem = {
    name:
      pmGradingRow.catalogue.clientProductTitle ??
      pmGradingRow.catalogue.clearCycleProductTitle,
    clientId: currentCC2?.client ?? "",
    clientItemId: pmGradingRow.catalogue.sku,
    clientSkuHyperlinks: [pmGradingRow.catalogue.listingLink].filter(
      (url) => !!url?.trim()
    ),
    clientImageLinks: pmGradingRow.catalogue.images,
    archived: false,
    retailPricePence: rrpPence,
    weightGrams: pmGradingRow.catalogue.boxKG
      ? pmGradingRow.catalogue.boxKG * 1000
      : undefined,
    identifiers: [],
    itemId: "item-001",
    colour: pmGradingRow.catalogue.color,
    auditHistory: [],
    description:
      pmGradingRow.catalogue.description ?? "No description provided",
    clearCycleImageLinks: pmGradingRow.catalogue.images,
    createdAtTimestamp: new Date().toISOString(),
    imageTags: [],
    lastUpdatedTimestamp: new Date().toISOString(),
    previousIdentifiers: [],
    // Product dims here
    // overallSize: {},
    boxCount: pmGradingRow.catalogue.boxes,
    dimensions: {
      boxes: [
        {
          height: pmGradingRow.catalogue.boxH,
          width: pmGradingRow.catalogue.boxW,
          length: pmGradingRow.catalogue.boxL,
        },
      ],
    },
  };

  return (
    <>
      <Row className="mb-2">
        <Col>
          <Button
            disabled={isRetrievingCatalogueItemForCurrentSKU || disabled}
            variant={"info"}
            onClick={() => getLatestCatalogueForActiveSku()}
          >
            {isRetrievingCatalogueItemForCurrentSKU ? (
              <Spinner size="sm" className="me-1" />
            ) : null}
            Get Latest Catalogue Item
          </Button>
        </Col>
        {onChangeCatalogue && (
          <Col>
            <Button
              onClick={onChangeCatalogue}
              disabled={disabled}
              variant={darkMode ? "light" : "dark"}
            >
              Request Catalogue Changes
            </Button>
          </Col>
        )}
      </Row>
      <CatalogItemPreviewComponent
        customClassNameCarousel="pmui-catalogue-preview"
        catalogItem={catalogInfoShim}
        width="100%"
        marginBottom="0.5em"
        hideFields={{
          costPricePence: true, // Hide cost price as it's not relevant here
        }}
      />
      {currentCC2 ? (
        <Button
          className="mt-2 mb-2 w-100"
          disabled={disabled}
          onClick={() =>
            window.open(
              `https://docs.google.com/spreadsheets/d/${currentCC2?.pmSpreadsheetId}`,
              "_blank"
            )
          }
          variant={darkMode ? "outline-light" : "outline-dark"}
        >
          <Link size={20} /> Open PM Spreadsheet
        </Button>
      ) : null}
      {process.env.REACT_APP_PM_CRAP_URL ? (
        <Button
          className="w-100"
          disabled={disabled}
          onClick={() =>
            window.open(process.env.REACT_APP_PM_CRAP_URL, "_blank")
          }
          variant={darkMode ? "outline-light" : "outline-dark"}
        >
          <Link size={20} /> Open Catalogue Request Amendment Pipeline
          (permissions required)
        </Button>
      ) : null}
    </>
  );
};

export default PMUICatalogueInfo;
